/**
 * Accordion Component
 * 
 * Handles accordion functionality with the ability to open only one item at a time.
 */

class Accordion {
	constructor(element) {
		this.accordion = element;
		this.items = Array.from(this.accordion.querySelectorAll('[data-accordion-item]'));
		this.allowMultiple = this.accordion.hasAttribute('data-accordion-multiple');
		
		this.init();
	}

	init() {
		this.items.forEach((item, index) => {
			const trigger = item.querySelector('[data-accordion-trigger]');
			const content = item.querySelector('[data-accordion-content]');
			
			if (!trigger || !content) return;

			// Set up ARIA attributes
			const itemId = `accordion-item-${Date.now()}-${index}`;
			const triggerId = `${itemId}-trigger`;
			const contentId = `${itemId}-content`;
			
			trigger.setAttribute('id', triggerId);
			trigger.setAttribute('aria-controls', contentId);
			content.setAttribute('id', contentId);
			content.setAttribute('role', 'region');
			content.setAttribute('aria-labelledby', triggerId);

			// Add click event
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				this.toggle(item);
			});
		});
	}

	toggle(targetItem) {
		const trigger = targetItem.querySelector('[data-accordion-trigger]');
		const content = targetItem.querySelector('[data-accordion-content]');
		const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

		// If not allowing multiple, close all other items first
		if (!this.allowMultiple) {
			this.items.forEach((item) => {
				if (item !== targetItem) {
					this.close(item);
				}
			});
		}

		// Toggle the target item
		if (isExpanded) {
			this.close(targetItem);
		} else {
			this.open(targetItem);
		}
	}

	open(item) {
		const trigger = item.querySelector('[data-accordion-trigger]');
		const content = item.querySelector('[data-accordion-content]');
		
		trigger.setAttribute('aria-expanded', 'true');
		content.setAttribute('data-accordion-open', '');
	}

	close(item) {
		const trigger = item.querySelector('[data-accordion-trigger]');
		const content = item.querySelector('[data-accordion-content]');
		
		trigger.setAttribute('aria-expanded', 'false');
		content.removeAttribute('data-accordion-open');
	}
}

// Initialize accordions
function initAccordions() {
	// Skip accordions managed by block-specific scripts (e.g. two-column accordion carousel).
	const accordions = document.querySelectorAll('[data-accordion]:not([data-carousel-sync])');
	accordions.forEach(accordion => {
		new Accordion(accordion);
	});
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initAccordions);
} else {
	initAccordions();
}

// Re-initialize after WordPress block editor updates
if (window.wp && window.wp.domReady) {
	wp.domReady(initAccordions);
}

// Export for potential external use
if (typeof module !== 'undefined' && module.exports) {
	module.exports = Accordion;
}
